import React from 'react';
import AdminProjectDetailCard from '../AdminProjectDetailCard/AdminProjectDetailCard';
import { useTranslate } from 'react-translate.ts';
import AdminReportTable from '../../report/AdminReportTable/AdminReportTable';
import Report from '../../../types/Report';
import { Skeleton } from '@tcc-online/common-components';
import styles from './AdminProjectDetailReports.module.scss';
import { Link } from 'react-router-dom';
import AdminButton from '../../buttons/AdminButton/AdminButton';

interface AdminProjectDetailReportsProps {
    reports: Report[];
    title: string;
    link?: string;
    loading?: boolean;
    prependPath?: (productType: number, projectId: number) => string;
}

const skeletons = Array.from(new Array(5), (_, index) => (
    <Skeleton key={index} className={styles.skeleton} />
));

export default function AdminProjectDetailReports(
    props: AdminProjectDetailReportsProps,
) {
    const { title, reports, loading, link, prependPath } = props;
    const translate = useTranslate();

    return (
        <AdminProjectDetailCard title={title}>
            {!loading ? (
                <AdminReportTable reports={reports} prependPath={prependPath} />
            ) : (
                skeletons
            )}
            {link && (
                <Link to={link} className={styles.link}>
                    <AdminButton>{translate('Prejit na vysledky')}</AdminButton>
                </Link>
            )}
        </AdminProjectDetailCard>
    );
}
